import { render } from "./FarmOSRemoveNoteDialog.vue?vue&type=template&id=67a8acee"
import script from "./FarmOSRemoveNoteDialog.vue?vue&type=script&lang=js"
export * from "./FarmOSRemoveNoteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__